const parseUrlStrings = (text) => {
  let response = text;
  const urlsToRemove = [
    'http://localhost:8080/admin/stories',
    'http://localhost:8080/admin/art',
    'http://artstory.s3-website.us-east-2.amazonaws.com/admin/stories',
    'http://artstory.s3-website.us-east-2.amazonaws.com/admin/art',
    'http://artstory.net/admin/stories',
    'http://artstory.net/admin/art',
    'https://localhost:8080/admin/stories',
    'https://localhost:8080/admin/art',
    'https://artstory.s3-website.us-east-2.amazonaws.com/admin/stories',
    'https://artstory.s3-website.us-east-2.amazonaws.com/admin/art',
    'https://artstory.net/admin/stories',
    'https://artstory.net/admin/art',
  ];
  urlsToRemove.forEach((url) => {
    // console.log(url);
    // console.log(response);
    response = response.replace(url, '');
    // console.log(response);
  });

  return response;

};

export {
  parseUrlStrings,
};
